import Select from "react-select";
import {useQuery} from "react-query";
import React, {useEffect, useState} from "react";
import {getActivitySessions, getAllActivities} from "Api/Query/ActivityQuery";
import {SelectOptionType} from "Model/Select/SelectOption";

interface Props {
    activityId: string,
    onChange: (newValue: SelectOptionType|SelectOptionType[]|null) => void,
    onActivitiesLoad?: (activities: any[]) => void,
    value?: any,
    classes?: string,
    placeholder?: string,
    filters?: {[key:string]:string|number},
    isMulti?: boolean
}

export const ActivitySessionSelect : React.FC<Props> = (props) => {

    const [options, setOptions] = useState<any>([])
    const [value, setValue] = useState<any>([])

    const activitySessionsQuery = useQuery({
        enabled: false,
        queryKey: ['getActivitySessions'],
        queryFn: () => getActivitySessions({
            activity: props.activityId,
            size: 0
        }),
        onSuccess: (response: any) => {
            const activitySessions : object[] = []
            response.data._result.items.map((item:any) => {
                activitySessions.push({
                    label: item.name,
                    value: item.id
                })
            })
            setOptions(activitySessions)

            if(props.onActivitiesLoad){
                props.onActivitiesLoad(response.data._result.items)
            }
        }
    })

    useEffect(() => {
        console.log('change act id', props.activityId)
        if(!props.activityId){
            return
        }

        setValue(null)
        activitySessionsQuery.refetch()
    }, [props.activityId])

    return (
        <Select
            isLoading={activitySessionsQuery.isRefetching}
            options={options}
            placeholder={props.placeholder ?? ""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            isMulti={props.isMulti ?? false}
            onChange={(newValue:any) => {
                    setValue(newValue)
                    props.onChange(newValue)
                }
            }
            className={props.classes ?? ''}
            isDisabled={(props.activityId ? false : true) || activitySessionsQuery.isRefetching}
            value={props.value !== undefined ? props.value : value}
        />
    )
}
